export const styles = {
  headCell: {
    backgroundColor: '#FAFAFA',
  },
  tableContainer: {
    borderRadius: '4px',
    overflow: 'auto',
    // border: '1px solid #D9D9D9',
    height: '440px',
  },
  headTableCell: {
    backgroundColor: '#FAFAFA',
  },
  tableRow: {
    cursor: 'pointer',
  },
  chip: {
    inlineSize: 'fit-content',
    height: '22px',
    borderRadius: '4px',
    fontWeight: 500,
    '&.MuiChip-colorDefault': {
      backgroundColor: '#EEE',
      color: '#787878',
      borderColor: '#8E8E8E',
    },
    '&.MuiChip-colorError': {
      backgroundColor: '#FFEAEA',
    },
    '&.MuiChip-colorSuccess': {
      backgroundColor: '#EFFFEE',
      color: '#33C341',
      borderColor: '#33C341',
    },
    '&:not(.MuiChip-colorPrimary) .MuiChip-label': {
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  scrollBar: {
    '*::-webkit-scrollbar': {
      width: '12px',
      height: '12px',
      backgroundColor: '#FAFAFA',
    },
    '*::-webkit-scrollbar-track:vertical': {
      backgroundColor: '#EEEEEE',
      //borderBottom: '2px solid white',
      marginTop: '67px',
      borderTop: '1px solid #D9D9D9',
    },
    '*::-webkit-scrollbar-track:horizontal': {
      backgroundColor: '#EEEEEE',
      //borderRight: '2px solid white',
    },
    '*::-webkit-scrollbar-track-piece:end': {
      //marginBottom: '-16px',
    },
    '*::-webkit-scrollbar-track-piece:start': {
      //marginTop: '-16px',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#BDBDBD',
      border: '2px solid transparent',
      borderRadius: '5px/5px',
      backgroundClip: 'content-box',
    },
    '*::-webkit-scrollbar-corner': {
      backgroundColor: '#EEEEEE',
      border: '1px solid #FFFFFF',
      borderRadius: '2px',
    },
  },
}
